<template>
  <div class="container">
    <div class="row advice-row">
      <div class="col-sm-1"></div>

      <div class="col-sm-2">
        <div class="iconwrap text-center"><img src="../../assets/img/advies-white_2.svg" height="55"></div>
      </div>
      <div class="col-sm-1"></div>
      <div class="col-sm-7">
        <div class="advice-wrap">
          <h4>{{ $t('schedule_advice') }}</h4>
          <h3>{{ adviceText }}</h3>
        </div>

        <div class="buttonwrap">
          <button class="advicebutton text-white confirm"
                  @click="$emit('open-modal')">
            <span>{{ $t('schedule_view') }}</span>
          </button>
        </div>
      </div>
      <div class="col-sm-1"></div>
    </div>
  </div>
</template>


<script>
  export default {
    props: ['advice-text'],
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/myschedule/AdviceBlock.vue